export default {
    amount: "Cantidad",
    price: "Precio",
    apply_monthly_change_now: "Aplicar diferencia este mes",
    update_button: "Actualizar",
    description: "Descripción",
    total: "Total",
    cost_per_tool: "Costo por Herramienta",
    see_all_costs: "Ver todos ({count})",
    credit: "Crédito",
    credits: "Créditos",
    no_cost_available:
        "No hay costos disponibles, ya que este establecimiento aún no tiene un plan de créditos.",
    add_plan: "Añadir un Plan",
    next_recharge: "Próxima recarga:",
    credits_in: "créditos en",
    recharge_history: "Historial de recargas",
    balance: "Saldo",
    month_year: "Mes / Año",
    expired: "Vencidos",
    available: "Disponible",
    expiration: "Vencimiento",
    monthly_plan: "Plan Mensual",
    monthly_adjustment: "Ajuste de Plan Mensual",
    extra_package: "Paquete Extra",
    not_informed: "No informado",
    monthly_plan_updated: "Plan mensual actualizado",
    page_title: "Créditos",
    load_error: "Ocurrió un error al cargar los datos financieros de su cuenta. Por favor, intente recargar la página.",
    usage_history_error: "No se pudo cargar el historial de uso en este momento.",
    not_enough_data: "No hay datos suficientes para el período.",
    data_load_error: "Ocurrió un error al cargar los datos. Por favor, inténtelo de nuevo.",
    no_active_package: "Ningún paquete de créditos activo en este momento.",
    current_balance: "Saldo actual",
    credit_options: "Opciones de crédito",
    adjust_monthly_package: "Ajustar Paquete Mensual",
    no_data_for_period: "Ningún dato para el período",
    consumption_by_action: "Consumo por acción:",
    action: "Acción",
    no_consumption_for_period: "Ningún consumo registrado en el período.",
    usage_history_title: "Historial de uso:",
    detailed_usage_statement: "Extracto Detallado de Uso",
    total_records_found: "Total de registros encontrados en el período: {count}",
    automation_campaign: "Automatización/Campaña",
    credits_consumed: "Créditos Consumidos",
    no_records_found: "Ningún registro encontrado en el período.",
    next: "Siguiente",
    previous: "Anterior",
    no_changes_detected: "No se detectaron cambios",
    price_difference_charged: "Valor cobrado por la diferencia: {amount}",
    generating_invoice: "¡Factura generada! Abriendo WhatsApp...",
    error_processing_invoice: "Error al procesar la solicitud de factura.",
    server_communication_error: "Fallo en la comunicación con el servidor.",
    whatsapp_msg_intro: "¡Hola! Tengo una solicitud de crédito:",
    whatsapp_msg_establishment: "Establecimiento: {name}",
    whatsapp_msg_requester: "Solicitante: {name}",
    whatsapp_msg_details_adjust: "Solicitud: Ajustar Paquete Mensual a {credits} créditos",
    whatsapp_msg_details_extra: "Solicitud: Paquete Extra de {credits} créditos",
    contract_button: "Contratar",
    inform_credits_amount: "Informe la cantidad de créditos deseada",
    credits_added_success: "¡Créditos añadidos con éxito!",
    error_processing_request: "Error al procesar la solicitud.",
    credits_statement: "Extracto",
    loading_data: "Cargando datos...",
    automation: "Automatización",
    campaign: "Campaña",
    page_x_of_y: "Página {current} de {total}",
    close: "Cerrar",
    manage_credits: "Gestionar créditos",
    view_recharge_history: "Ver historial de recargas",
    consumption_estimated_end_month: "Consumo estimado hasta fin de mes: {amount} créditos",
    no_credits_available: "Ya no tienes créditos disponibles",
    expires_in: "Vence en",
    next_packages_available: "Próximos paquetes disponibles",
    view_full_history: "Ver historial completo",
    group_daily: "Diario",
    group_weekly: "Semanal",
    group_monthly: "Mensual",
    group_quarterly: "Trimestral",
    period_too_long_daily: "Período demasiado largo para la vista diaria",
    period_too_long_weekly: "Período demasiado largo para la vista semanal",
    period_too_short_weekly: "Seleccione al menos 2 semanas para la vista semanal",
    period_too_short_monthly: "Seleccione al menos 2 meses para la vista mensual",
    period_too_short_quarterly: "Seleccione al menos 6 meses para la vista trimestral",
    tooltip_others: "Otras ({count} automatizaciones)",
    daily_average: "Promedio diario: {amount} créditos",
    consumption_by_branch: "Consumo por sucursal:",
    consumption_by_category: "Consumo por categoría:",
    no_automation_found: "No se encontró ninguna automatización o campaña en el período.",
    action_type_manual: "Ajuste Manual",
    action_type_other: "Otros",
    download_csv: "Descargar CSV",
    date_time: "Fecha/Hora",
    credits_consumption: "Consumo de Créditos",
    expires_at_small: "vence",
    load_statement_error: "Error al cargar los datos del extracto.",
    prepare_csv_error: "Error al preparar la exportación CSV.",
    no_branch: "Sin sucursal",
    other: "Otros",
    // Filter labels
    filter_by_date: "Filtrar por fecha",
    action_type_filter: "Tipo de acción",
    all_actions: "Todas las acciones",
    automations_filter: "Automatizaciones",
    campaigns_filter: "Campañas",
    in_automations: "En automatizaciones:",
    in_campaigns: "En campañas:",
    total_consumed: "Total de créditos consumidos:",
    status_filter: "Estado",
    active: "Activos",
    inactive: "Inactivos",
    segments: "Segmentos",
    // Package labels
    consumed: "consumido",
    used: "usado",
    credit_package: "Paquete de créditos",
    monthly_package_label: "Paquete Mensual",
    single_package_label: "Paquete Individual",
    monthly_partial_label: "Ajuste Mensual",
    // Notifications
    monthly_plan_updated: "Plan actualizado",
    monthly_plan_update_error: "Error al actualizar el plan",
    balance_load_error: "Error al cargar los datos de saldo. Por favor, recargue la página.",
    // Misc
    date: "Fecha",
    action_type_other: "Otros",
    unknown: "Desconocido",
    expand_chart: "Expandir gráfico",
    category: "Categoría",
    trigger: "Gatillo",
    action_type_whatsapp: "WhatsApp",
    action_type_whatsapp_api: "WhatsApp (API)",
    action_type_sms: "SMS",
    action_type_rcs: "RCS",
    action_type_email: "E-mail",
    action_type_ai: "IA",
    action_type_task: "Tarea",
    action_type_task_ai: "Tarea con IA",
    action_type_webhook: "WebHook",
    action_type_ai_basic: "IA Básica",
    action_type_ai_advanced: "IA Avanzada",
    action_type_ai_gpt5: "IA Avanzada (GPT-5)",
    action_type_ai_selection: "Selección por IA",
    action_type_smart_insertion: "Inserción Inteligente",
    action_type_plugin: "Acción de Plugin",
    action_type_automation: "Automatización",
    trigger_birthday: "Cumpleaños",
    trigger_specific_date: "Fecha Específica",
    trigger_registration: "Registro",
    trigger_purchase: "Compra",
    trigger_points: "Puntos Acumulados",
    trigger_inactivity: "Inactividad",
    view_full_statement: "Ver extracto completo",
    back_to_credits: "Volver a Créditos",
    credit_statement_title: "Extracto de Créditos",
    credit_statement_subtitle: "Consulta tus créditos en detalle",
    load_periods_error: "Ocurrió un error al cargar los períodos disponibles. Por favor, intente recargar la página.",
    no_statement_available: "No hay extracto disponible en este momento.",
    period_colon: "Período:",
    select_month_placeholder: "Seleccione el mes deseado...",
    usage_details: "Detalles del Uso",
    consumed_value: "Valor Consumido",
    linked_client_id: "ID Cliente Vinculado",
    credit_type: "Tipo de Crédito",
    execution_id: "ID Ejecución",
    no_transactions_for_month: "No se encontraron transacciones para {month}."
};
